import { render, staticRenderFns } from "./UserAuth.vue?vue&type=template&id=b6cdf266&scoped=true&"
import script from "./UserAuth.vue?vue&type=script&lang=ts&"
export * from "./UserAuth.vue?vue&type=script&lang=ts&"
import style0 from "./UserAuth.vue?vue&type=style&index=0&id=b6cdf266&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6cdf266",
  null
  
)

export default component.exports